<template>
  <div class="c-select">
    <div class="c-select__value" v-on:click="showList = !showList">
      <slot name="value"></slot>
    </div>
    <div
      class="c-select__overlayer"
      v-bind:class="{ 'c-select__overlayer--show': showList }"
      v-on:click="showList = !showList"
    ></div>
    <div class="c-select__list" v-bind:class="{ 'c-select__list--show': showList }">
      <div class="c-select__list__container">
        <h2><slot name="title"></slot></h2>
        <div
          class="c-select__list__container__content"
          v-on:click="showList = hideOnSelect ? false : true"
        >
          <slot name="list"></slot>
        </div>
      </div>
      <div class="c-select__close" v-on:click="showList = !showList">Zamknij</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showList: false,
    };
  },
  props: {
    hideOnSelect: {
      default() {
        return false;
      },
    },
    show: {
      type: Boolean,
      default: () => true,
    },
  },
  watch: {
    showList() {
      document.documentElement.style.overflow = state ? "hidden" : "auto";
    },
  },
};
</script>
<style lang="scss">
@import "../_variables.scss";
.c-select {
  max-width: 536px;
  &--center {
    margin: 0 auto;
  }
  &__value {
    z-index: 666;
    padding: 0.5rem 2rem;
    font-weight: 100;
    text-align: left;
    font-size: 1.25rem;
    color: $darkGray;
    border: 1px solid $black;
    cursor: pointer;
    transition: background 0.25s;
    margin: 0 0.5rem;
    &:hover {
      background: none;
      position: relative;
      &::before {
        content: " ";
        display: block;
        position: absolute;
        top: 0rem;
        left: 0rem;
        right: 0rem;
        bottom: 0rem;
      }
    }
  }
  &__list {
    z-index: 666;
    position: fixed;
    top: 0;
    bottom: 0;
    transform: translateY(100%);
    opacity: 0.2;
    transition: transform 0.6s, opacity 0.5s;
    &__container {
      padding: 1.5rem 1rem;
      background: #fff;
      width: 536px;
      min-height: 200px;
      max-width: calc(100vw - 2rem);
      text-align: left;
      &__content {
        overflow-y: auto;
        margin: 1rem 0;
        max-height: 420px;
        ul {
          margin: 0;
          padding: 0;
          list-style-type: none;
          li {
            padding: 0.25rem 1rem;
            &:hover {
              background: $ultraBrightGray;
              cursor: pointer;
            }
            &.active {
              background: $green;
              color: #fff;
            }
          }
        }
      }
    }
    &--show {
      margin-top: 40vh;
      margin-bottom: 0;
      opacity: 1;
      transform: translateY(-50%);
    }
    h2 {
      font-size: 1rem;
      margin: 0;
      padding: 0;
      text-align: center;
    }
  }
  &__close {
    padding: 0.5rem 2rem;
    font-weight: 100;
    text-align: center;
    font-size: 1.25rem;
    color: $darkGray;
    background: $ultraBrightGray;
    cursor: pointer;
    margin-top: 0.5rem;
    transition: background 0.25s;
    &:hover {
      background: $green;
      color: #fff;
    }
  }
  &__overlayer {
    z-index: 666;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: $ultraDarkGrayTransparent;
    transform: translateY(-100%);
    opacity: 0.2;
    transition: transform 0.4s, opacity 0.1s;
    &--show {
      transform: translateY(0%);
      opacity: 1;
    }
  }
}
</style>
